<!-- 现有库存 -->
 <template>
    <div style="display: flex;flex-direction: column;  overflow: hidden;height: calc(100vh - 85px) ;background-color: #ffffff;">
        <div style=" flex-shrink: 0;">
            <el-form class="demo-form-inline inventoryForm" :inline="true" ref="inventoryForm" :model="inventoryForm" 
             size="mini" label-width="120px">
                <el-form-item label="提单号" prop="blNo"> 
                    <el-input  v-model="inventoryForm.blNo" placeholder="请输入提单号" clearable ></el-input>
                </el-form-item>
                <el-form-item label="报关单号" prop="cusDeclNo"> 
                    <el-input  v-model="inventoryForm.cusDeclNo" placeholder="请输入报关单号" clearable ></el-input>
                </el-form-item>
                <el-form-item label="核注清单号" prop="invDecNo"> 
                    <el-input  v-model="inventoryForm.invDecNo" placeholder="请输入核注清单号" clearable ></el-input>
                </el-form-item>
                <el-form-item label="货物名称" prop="goodsName"> 
                    <el-select class="width_100" filterable :default-first-option="true" remote :remote-method="getGoodsList"
                        placeholder="请选择货物名称" v-model="inventoryForm.goodsName" clearable>
                        <el-option v-for="item in goodsList" :key="item.id" :label="item.goodsName" :value="item.goodsName">
                            <span class="margin_right_20">{{ item.goodsName }}</span>
                            <span class="margin_right_20">{{ item.goodsType }}</span> 
                            <span >{{ item.hsCode }}</span> 
                        </el-option>
                    </el-select>
                </el-form-item>
                
                <el-form-item label="海关编码" prop="hsCode"> 
                    <el-input  v-model="inventoryForm.hsCode" placeholder="请输入海关编码" clearable></el-input>
                </el-form-item>
                <el-form-item label="委托单位" prop="customer"> 
                    <el-select filterable placeholder="请选择委托单位" v-model="inventoryForm.customer" clearable >
                        <el-option v-for="item in customerList" :key="item.id" :label="item.companyName" :value="item.companyName"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="货主单位" prop="ownerName"> 
                    <el-select filterable placeholder="请选择货主单位" v-model="inventoryForm.ownerName" clearable >
                        <el-option v-for="item in customerList" :key="item.id" :label="item.companyName" :value="item.companyName"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="保税类型" prop="isBonded"> 
                     <el-select  placeholder="请选择保税类型" v-model="inventoryForm.isBonded" clearable >
                        <el-option v-for="item in bondedTypeList" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="仓库" prop="ckName"> 
                    <el-select placeholder="请选择仓库" v-model="inventoryForm.ckName" @change="changeCkName">
                        <el-option v-for="item in ckNameList" :key="item" :label="item" :value="item"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="库区" prop="place"> 
                    <el-select class="width_100" @change="placeEnter" v-model="inventoryForm.place" placeholder="请选择库区" clearable>
                        <el-option v-for="item in placeList"  :key="item.name" :label="item.name " :value="item.name + '-' + item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="库位" prop="location">
                    <el-select class="width_100" filterable v-model="inventoryForm.location" placeholder="请选择库位" clearable>
                        <el-option v-for="item in locationList"  :key="item.locationName" :label="item.locationName " :value="item.locationName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="箱号" prop="boxNo"> 
                    <el-input  v-model="inventoryForm.boxNo" placeholder="请输入箱号" clearable ></el-input>
                </el-form-item>
                <el-form-item label="规格型号" prop="spec"> 
                    <el-input  v-model="inventoryForm.spec" placeholder="请输入规格型号" clearable ></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="note"> 
                    <el-input  v-model="inventoryForm.note" placeholder="请输入备注" clearable ></el-input>
                </el-form-item>
                <el-form-item label="入库日期" prop="completeDate"> 
                    <el-date-picker clearable style="width:193px" v-model="inventoryForm.completeDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"> </el-date-picker>
                </el-form-item>
                 <el-form-item label="库存时间" prop="createTime"> 
                    <!-- v-model="inventoryForm.createTime" -->
                    <el-date-picker clearable style="width:193px" v-model="displayCreateTime"  type="date" value-format="yyyy-MM-dd" 
                    placeholder="选择日期"> </el-date-picker>
                </el-form-item>
                <el-form-item label=""> 
                    <el-button size="mini" @click="resetForm">重置</el-button>
                    <el-button type="primary" size="mini" @click="wmsGetStockList">搜索</el-button>
                    <el-button type="primary" size="mini" @click="exportwmsList(false)" v-if="inventoryForm.ckName !== '纽约路仓库' ">导出</el-button>
                    <el-dropdown v-else trigger="click" @command="(command) => exportWMS(command)" style="margin-left:10px;">
                        <span class="el-dropdown-link">
                            <el-button type="primary" size="mini" >导出</el-button>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="库存列表">库存列表</el-dropdown-item>
                            <el-dropdown-item command="库存列表合并硫磺">库存列表合并硫磺</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </el-form-item>
            </el-form>
        </div>
        <div style="flex:1;overflow: hidden" >
            <vxe-table  id="inventoryTable"  size="mini" ref="inventoryTable" :data="inventoryList" border stripe  :row-style="rowStyle"
                :column-config="{resizable: true,sortable: true}"  header-align="center" :row-config="{ isHover: true, isCurrent: true}" 
                :radio-config="{labelField: '', highlight: true}"  :footer-method="footerMethod" show-footer height="auto"
                show-overflow show-header-overflow show-footer-overflow  :virtual-y-config="{enabled: true, gt: 100}" 
                :menu-config="menuConfig"  @menu-click="handleMenuClick">
                    <!-- <vxe-column type="radio" fixed="left" width="50"></vxe-column> -->
                <vxe-column type="seq" width="50" fixed="left"></vxe-column>
                <vxe-column field="blNo" title="提单号" width="130" fixed="left"></vxe-column>
                <vxe-column field="goodsName" title="货物名称" width="140" fixed="left"></vxe-column>
                <vxe-column field="ownerName" title="货主单位" width="200" fixed="left"></vxe-column>
                <vxe-column field="customer" title="委托单位" width="200"></vxe-column>
                <vxe-column field="goodsType" title="货物分类" width="100"></vxe-column>
                <vxe-column field="isBonded" title="保税类型" width="70"></vxe-column>
                <vxe-column field="spec" title="规格型号" min-width="150"></vxe-column>
                <vxe-column field="hsCode" title="海关编码" width="100"></vxe-column>
                <vxe-column field="invDecNo" title="核注清单号" width="140"></vxe-column>
                <vxe-column field="cusDeclNo" title="报关单号" width="140"></vxe-column>
                <vxe-column field="skuNo" title="商品料号" width="140"></vxe-column>
                <vxe-column field="itemNo" title="项号" width="100"></vxe-column>
                <vxe-column field="boxNo" title="箱号" width="120">
                    <!-- <template template #default="{ row }">
                         <vxe-button mode="text" status="primary" size="mini"@click="seacherLotNo(row)">{{ row.boxNo }}</vxe-button>
                    </template> -->
                </vxe-column>
                <vxe-column field="handbook" title="账册编号" width="110"></vxe-column>
                <vxe-column field="createDate" title="入库日期" width="100" sortable></vxe-column>
                <vxe-column field="stockDateNum" title="库龄" width="80"></vxe-column>
                <vxe-column field="ckName" title="仓库" width="100"></vxe-column>
                <vxe-column field="place" title="库区" width="100"></vxe-column>
                <vxe-column field="location" title="库位" width="100"></vxe-column>
                <vxe-column field="totalNetWeight" title="净重" width="100"  align="right"  :formatter="formatThousandSeparator"></vxe-column>
                <vxe-column field="totalQty1" title="件数1" width="100"  align="right" :formatter="formatThousandSeparator"></vxe-column>
                <vxe-column field="qty1UnitName" title="件数1单位" width="100"></vxe-column>
                <vxe-column field="totalQty2" title="件数2" width="100"  align="right" :formatter="formatThousandSeparator"></vxe-column>
                <vxe-column field="qty2UnitName" title="件数2单位" width="100"></vxe-column>
                <vxe-column field="decPrice" title="申报单价" width="100" align="right"></vxe-column>
                <vxe-column field="decUnitName" title="申报单位" width="100"></vxe-column>
                <vxe-column field="totalDecNum" title="申报数量" width="100"  align="right" :formatter="formatThousandSeparator"></vxe-column>
                <vxe-column field="totalDecAmount" title="申报金额" width="100"  align="right" :formatter="formatThousandSeparator"></vxe-column>
                <vxe-column field="decCurrency" title="币制" width="100" ></vxe-column>
                <vxe-column field="lawUnitFirstName" title="法定第一单位" width="100"></vxe-column>
                <vxe-column field="totalFirstNum" title="法定第一数量" width="100"  align="right" :formatter="formatThousandSeparator"></vxe-column>
                <vxe-column field="lawUnitSecond" title="法定第二单位" width="100"></vxe-column>
                <vxe-column field="totalSecondNum" title="法定第二数量" width="100"  align="right" :formatter="formatThousandSeparator"></vxe-column>
                <vxe-column field="note" title="备注" width="100" ></vxe-column>
                <vxe-column field="lotNo" title="LOT号" width="100"  ></vxe-column>
                <vxe-column field="lotKgs" title="LOT重量" width="80" ></vxe-column>
                <vxe-column field="lotOrderNo" title="LOT订单号" width="100" ></vxe-column>
                <vxe-column field="lotMaterialNo" title="LOT物料号" width="100" ></vxe-column>
            </vxe-table>
        </div>
        <vxe-pager align="left" :current-page.sync="pagination.currentPage" :page-size.sync="pagination.pageSize" :page-sizes="pageSizes"
            :total="pagination.total" @page-change="wmsGetStockListPager" size="mini">
        </vxe-pager>
        <el-dialog title="保税提离" :visible.sync="overduePickVisible" :close-on-click-modal="false"  width="75%" 
        :before-close="overduePickClose" v-dialogDrag>
            <el-form ref="overduePickForm" :model="overduePickForm" label-width="160px" size="mini" :rules="overduePickFormRules">
                <el-form-item label="提单号" prop="blNo">
                    <el-input disabled v-model="overduePickForm.blNo"></el-input>
                </el-form-item>
                <el-form-item label="仓库名称" prop="ckName">
                    <el-input disabled v-model="overduePickForm.ckName"></el-input>
                </el-form-item>
                <el-form-item label="报关日期" prop="declareDate">
                    <el-date-picker v-model="overduePickForm.declareDate" type="date" value-format="yyyy-MM-dd"  placeholder="" style="width:100%"
                    > </el-date-picker>
                </el-form-item>
                <el-form-item label="申报数量(KG)" prop="blKgs">
                    <el-input v-model="overduePickForm.blKgs"></el-input>
                </el-form-item>
                <el-form-item label="客户经理" prop="notifyPerson">
                    <el-select clearable class="width_100" filterable :default-first-option="true" 
                    v-model="overduePickForm.notifyPerson" placeholder="请选择客户经理"  >
                        <el-option v-for="item in userList"  :key="item.id" :label="item.name " :value="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="overduePickForm.remark"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="overduePickClose">取 消</el-button>
                <el-button size="mini" type="primary" @click="saveOverduePick">保 存</el-button>
            </span>
        </el-dialog>
        <el-dialog title="修改库存备注" :visible.sync="exitNoteVisible" :close-on-click-modal="false"  width="40%" 
        :before-close="exitNoteClose" v-dialogDrag>
            <el-input v-model="exitNoteTextarea" type="textarea" :rows="2"></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="exitNoteClose">取 消</el-button>
                <el-button size="mini" type="primary" @click="saveExitNote">保 存</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import ExcelJS from 'exceljs';
export default {
    name: 'inventoryList',
    components:{
    },
    watch: { 
        'overduePickForm.blKgs'(newVal){
            // 空值直接清空返回
            if (newVal === '' || newVal === null || newVal === undefined) {
                this.overduePickForm.blKgs = ''
                return
            }
            // 强制转为字符串，保证可以调用match
            const strVal = String(newVal)
            const reg = /^[1-9]\d*\.?\d{0,4}|0\.\d{1,4}/
            const matchRes = strVal.match(reg)
            let legalNum = matchRes ? matchRes[0] : ''

            // const maxWeight = Number(this.overduePickSelect.totalNetWeight)
            // const num = Number(legalNum)
            // 合法数字且大于最大值时重置
            // if (!isNaN(num) && num > maxWeight) {
            //     legalNum = String(maxWeight)
            //     this.$message.warning(`重量不能超过${maxWeight}`)
            // }
            // 赋值回去
            this.overduePickForm.blKgs = legalNum
        }
    },
    computed:{
        // 用于显示的日期（不带时间）
        displayCreateTime: {
            get() {
                // 获取时，如果有时间部分，只返回日期部分
                if (!this.inventoryForm.createTime) return '';
                return this.inventoryForm.createTime.split(' ')[0];
            },
            set(value) {
                // 设置时，自动添加 23:59:59
                this.inventoryForm.createTime = value ? `${value} 23:59:59` : '';
            }
        }
    },
    data() {
        const menuConfig = {
            //   header: {
            //     options: [[{ code: 'myExportMenu', name: '导出数据' }]]
            //   },
            body: {
                options: [
                    [
                        { code: 'overduePick', name: '保税提离' },
                    ],
                    [
                        { code: 'exitNote', name: '修改库存备注' },
                    ]
                ]
            },
            //   footer: {
            //     options: [[{ code: 'myLinkMenu', name: '打开官网' }]]
            //   }
        } // 右击菜单
        return{
            inventoryForm:{
                goodsName:'',
                completeDate:'',
                blNo:'',
                hsCode:'',
                customer:'',
                ckName:'',
                location:'',
                ownerName:'',
                cusDeclNo:'',
                invDecNo:'',
                customer:'',
                isBonded:'',
                boxNo:'',
                createTime:'',
                spec:'',
                note:'',
            }, // 查询表单
            inventoryList:[], // 库存列表
            goodsList:[], // 货物名称列表
            customerList:[], // 委托单位列表
            ckNameList:[], // 仓库列表
            placeList:[], // 库区列表
            locationList:[], // 库位列表
            bondedTypeList:[], // 保税类型列表
            LOTNodialogVisible:false, // lot号弹窗
            lotNoTableList:[], // LOT号列表
            // 分页信息
            pagination:{
                totalPages: 0, // 总页数
                total: 0, // 总条数
                currentPage: 1, // 当前页数
                pageSize: 50, // 每页显示多少条数据
            },
            totalFooterData:{
                totalDecAmount: '',
                totalDecNum: '',
                totalFirstNum: '',
                totalNetWeight: '',
                totalQty1: '',
                totalQty2: '',
                totalSecondNum: '',
            },
            pageSizes:[10,15,20,50,100,200],
            menuConfig,
            overduePickVisible:false,
            exitNoteVisible:false,
            exitNoteRow:{}, // 修改库存备注行数据
            exitNoteTextarea:'', // 修改库存备注
            overduePickForm:{ // 保税提离
                blNo:'',
                declareDate:'',
                ckName:'',
                blKgs:'',
                notifyPerson:'',
                remark:'',
            },
            userList:[], // 用户数据
            // 选中的库存
            overduePickSelect:{},
            overduePickFormRules:{
                declareDate:[
                    { required: true, message: '请选择报关日期', trigger: 'change' }
                ],
                blKgs:[
                    { required: true, message: '请输入申报数量', trigger: 'blue' }
                ],
                notifyPerson:[
                    { required: true, message: '请选择客户经理', trigger: 'change' }
                ],
            },
        }
    },
    async created() {
        // 获取仓库
        await this.getckNameList()
        // 查询库存
        await this.wmsGetStockList()
        // 查询客户列表
        this.getCompanyList()
        // 获取保税属性
        this.getIsBonded()
        // 查询用户
        this.getUserList()
    },
    mounted() {

    },
    methods: {
        formatNumber({ cellValue }) {
            // 1. 处理空值
            if (cellValue == null || cellValue === '') return '';
             // 2. 尝试转换为数字
            const num = Number(cellValue);
            // 3. 检查转换是否成功
            if (isNaN(num)) return cellValue;
            // 4. 使用国际化 API 格式化数字
            return num.toLocaleString('en-US', {
                minimumFractionDigits: 2, // 最少保留2位小数
                maximumFractionDigits: 2// 最多保留2位小数
            });
        },
        // 合计表格表尾
        footerMethod({ columns, data }) {
            // 定义需要显示合计的字段
            const sumFields = ['totalNetWeight','totalQty1','totalQty2','totalDecNum','totalDecAmount','totalFirstNum','totalSecondNum'];
            
            // 计算合计值
            // const sums = {};
            // sumFields.forEach(field => {
            //     sums[field] = data.reduce((acc, row) => {
            //     return acc + (Number(row[field]) || 0);
            //     }, 0);
            // });
      
            return [
                columns.map((column, columnIndex) => {
                    const { field } = column;
                
                    // 第一列显示"合计"
                    if (columnIndex === 0) {
                        return '合计';
                    }
                
                    // 如果字段需要合计，显示合计值
                    if (sumFields.includes(field)) {
                        return this.formatNumber({ cellValue: this.totalFooterData[field] });
                    }
                
                    // 其他列显示"-"
                    return '-';
                })
            ];
        },
        // 格式化列，千位分隔符
        formatThousandSeparator({ cellValue, column }) {
            if (cellValue == null || cellValue === '') return '';
            
            const num = Number(cellValue);
            if (isNaN(num)) return cellValue;
            
            // 定义需要格式化的列
            const formatColumns = [
                'totalNetWeight',
                'totalQty1', 
                'totalQty2',
                'totalDecNum',
                'totalDecAmount',
                'totalFirstNum',
                'totalSecondNum'
            ];
            
            // 检查当前列是否需要格式化
            if (formatColumns.includes(column.field)) {
                // 使用 Intl.NumberFormat 格式化，保留2位小数
                return new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
                }).format(num);
            }
            
            return cellValue; // 不需要格式化的列返回原值
        },
        // 行颜色
        rowStyle({ row }) {
            if (row.lock === 1) {
            return {
                backgroundColor:'#f3cccc', // 红色
            }
            }
            return {}
        },
        // 查询库存
        wmsGetStockList(){
            this.pagination.currentPage = 1
            this.$api.wmsGetStockList( this.inventoryForm,this.pagination.pageSize,this.pagination.currentPage ).then(res =>{
                this.inventoryList = res.records
                this.pagination.total = res.total
                this.pagination.currentPage = res.current
                this.pagination.pageSize = res.size
                // 合计数据
                this.totalFooterData.totalDecAmount = res.totalDecAmount
                this.totalFooterData.totalDecNum = res.totalDecNum
                this.totalFooterData.totalFirstNum = res.totalFirstNum
                this.totalFooterData.totalNetWeight = res.totalNetWeight
                this.totalFooterData.totalQty1 = res.totalQty1
                this.totalFooterData.totalQty2 = res.totalQty2
                this.totalFooterData.totalSecondNum = res.totalSecondNum
            })
        },
        // 获取所有用户
        getUserList(){
            this.$api.getUserList( ).then(res =>{
                this.userList = res;
            })
        },
        // 分页查询 
        wmsGetStockListPager(){
            this.$api.wmsGetStockList(this.inventoryForm,this.pagination.pageSize,this.pagination.currentPage ).then(res =>{
                this.inventoryList = res.records
                this.pagination.total = res.total
                this.pagination.currentPage = res.current
                this.pagination.pageSize = res.size
            })
        },
        // 重置表单
        resetForm(){
            this.$nextTick(()=>{
                this.$refs.inventoryForm.resetFields();
            })
        },
        // 获取货物计划列表
        getGoodsList(value){
            this.$api.wmsgetListBy( 1,100,{param:value} ).then(res =>{
                this.goodsList = res.tableData
            })
        }, 
        // 获取客户信息
        getCompanyList(){
            this.$api.getCompanyList(  ).then(res =>{
                this.customerList = res.tableData
            })
        },
        // 获取保税属性
        getIsBonded(){
            this.$api.getDicList( { value:'Wms保税属性'} ).then(res =>{
                this.bondedTypeList = res
            })
        },
        // 获取仓库
        getckNameList(){
            return  this.$api.getCkNamesBy(  ).then(res =>{
                this.ckNameList = res
                // 赋值查询条件
                this.inventoryForm.ckName = this.ckNameList[0]
            })
        },
        // 获取库区列表
        getStore(){
            this.$api.getStore( this.inventoryForm.ckName ).then(res =>{
                this.placeList = res
            })
        },
        // 查询库位列表
        getLocation(id){
            this.$api.getLocation( id ).then(res =>{
                this.locationList = res
            })
        },
        // 选择仓库后查询库区
        changeCkName(){
            if( this.inventoryForm.ckName){
                this.inventoryForm.place = ''
                this.inventoryForm.location = ''
                this.getStore()
            }
        },
        // 根据库区查询库位列表
        placeEnter(value){
            if(value === ''){
                this.inventoryForm.place = ''
                this.locationList = []
            }else{
                const item  = value.split('-')
                this.inventoryForm.place = item[0]
                this.getLocation(item[1])
            }
            this.inventoryForm.location = ''
        },
        // 导出实时库存列表
        async exportwmsList(code){

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');
            const columns = [
                { header: '入库日期', key: 'createDate', width: 20 },
                { header: '账册编号', key: 'handbook', width: 20 },
                { header: '商品料号', key: 'skuNo', width: 20 },
                { header: '海关编码', key: 'hsCode', width: 20 },
                { header: '货主单位', key: 'ownerName', width: 20 },
                { header: '货物分类', key: 'goodsType', width: 20 },
                { header: '货物名称', key: 'goodsName', width: 20 },
                { header: '保税类型', key: 'isBonded', width: 20 },
                { header: '项号', key: 'itemNo', width: 20 },
                { header: '规格型号', key: 'spec', width: 20 },
                { header: '提单号', key: 'blNo', width: 20 },
                { header: '箱号', key: 'boxNo', width: 20 },
                { header: '报关单号', key: 'cusDeclNo', width: 20 },
                { header: '核注清单号', key: 'invDecNo', width: 20 },
                { header: '仓库', key: 'ckName', width: 20 },
                { header: '库区', key: 'place', width: 20 },
                { header: '库位', key: 'location', width: 20 },
                { header: '库龄', key: 'stockDateNum', width: 20 },
                // { header: '净重（KG）', key: 'totalNetWeight', width: 20 },
                { header: '净重（KG）', key: 'totalNetWeight', width: 20, style: { numFmt: '0.000' }}, // 设置数字格式
                // { header: '件数1', key: 'totalQty1', width: 20 },
                { header: '件数1', key: 'totalQty1', width: 20, style: { numFmt: '0.000' }}, // 设置数字格式
                { header: '件数1单位', key: 'qty1UnitName', width: 20 },
                // { header: '件数2', key: 'totalQty2', width: 20 },
                { header: '件数2', key: 'totalQty2', width: 20, style: { numFmt: '0.000' }}, // 设置数字格式
                { header: '件数2单位', key: 'qty2UnitName', width: 20 },
                // { header: '申报数量', key: 'totalDecNum', width: 20 },
                { header: '申报数量', key: 'totalDecNum', width: 20, style: { numFmt: '0.000' }}, // 设置数字格式
                { header: '申报单位', key: 'decUnitName', width: 20 },
                // { header: '申报金额', key: 'totalDecAmount', width: 20 },
                { header: '申报金额', key: 'totalDecAmount', width: 20, style: { numFmt: '0.000' }}, // 设置数字格式
                { header: '币制', key: 'decCurrency', width: 20 },
                
            ];
              // 设置表头
            worksheet.columns = columns;
            // 添加数据行
            var inventoryAllList = []
            // 是否合并硫磺
            if(code){
                // 合并
                await this.$api.wmsGetDayStock( this.inventoryForm.ckName ).then(res =>{
                    inventoryAllList = res
                })
            }else{
                // 不合并
                await this.$api.wmsGetStockList( this.inventoryForm,5000,1 ).then(res =>{
                    inventoryAllList = res.records
                })
            }
            inventoryAllList.forEach(item => {
                worksheet.addRow(item);
            });
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${this.getFormattedDateTime(code)}`;
            link.click();
            window.URL.revokeObjectURL(url);
        },
        getFormattedDateTime(code) {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day}_${hours}:${minutes}:${seconds} ${code ? '库存数据合并硫磺' : '库存数据'}`;
        },
        // 导出库存列表选择
        exportWMS(command){
            switch (command) {
                case '库存列表':
                    this.exportwmsList(false);
                    break;
                case '库存列表合并硫磺':
                    this.exportwmsList(true);
                    break;
                default:
                    this.$message.warning('未知的打印类型');
            }
        },

        // // 查看上传的lot号
        // seacherLotNo(row){
        //     this.$api.wmsGetLotsInStock(row.blNo,row.boxNo).then(res =>{
        //         this.lotNoTableList = res
        //         this.LOTNodialogVisible = true
        //     })
        //     // .catch(error => {
        //     //     console.error('查询失败:', error);
        //     //     this.$message.error('查询失败');
        //     // });
            
        // },
        // 打开保税提离弹窗
        overduePick(row){
            // 验证是否保税
            if(row.isBonded !== '保税'){
                this.$message.error('非保税货物不可保税提离')
                return false
            }
            this.overduePickSelect = JSON.parse(JSON.stringify(row))
            this.overduePickForm.blNo = row.blNo
            this.overduePickForm.blKgs = row.totalNetWeight
            this.overduePickForm.ckName = row.ckName

            const now = new Date();
            const year = now.getFullYear();
            // 月份从0开始，+1，不足两位补0
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            this.overduePickForm.declareDate =  `${year}-${month}-${day}`

            this.overduePickVisible = true
        },
        // 右击菜单
        handleMenuClick(params){
            const { menu, row } = params
            if (menu.code === 'overduePick') {
                this.overduePick(row)
            }else if(menu.code === 'exitNote'){
                this.exitNote(row)
            }
        },
        // 保存保税提离
        saveOverduePick(){
            this.$refs.overduePickForm.validate(async (valid) => {
                if (valid) {
                    this.$api.wmsAddOverduePick(this.overduePickForm).then(res =>{
                        this.$message.success('已添加到待提离列表')
                        this.overduePickClose()
                    })
                    
                }
            })
        },
        // 关闭弹窗
        overduePickClose(){
            this.overduePickVisible = false
            this.overduePickSelect = {}
            this.$refs.overduePickForm.resetFields();
        },
        // 修改库存备注
        exitNote(row){
            this.exitNoteRow = row
            this.exitNoteVisible = true
        },
        // 保存库存备注
        saveExitNote(){ 
            // 判断是否输入备注
            if(this.exitNoteTextarea){
                this.exitNoteRow.note = this.exitNoteTextarea
                this.$api.wmsModifyStockNote(this.exitNoteRow).then(res =>{
                    this.$message.success('修改备注成功')
                    this.exitNoteClose()
                    this.wmsGetStockList()
                })
            }else{
                this.$message.warning('请输入备注')
            }
        },
        // 关闭修改库存备注
        exitNoteClose(){
            this.exitNoteVisible = false
            this.exitNoteTextarea = ''
        },
    }
}
</script>
<style style lang="less" scoped>
.width_100{
    width: 100%;
}
.inventoryForm .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
    margin-bottom: 5px;
}
</style>